import { render, staticRenderFns } from "./course-work-details.vue?vue&type=template&id=2d9d959f&scoped=true"
import script from "./course-work-details.vue?vue&type=script&lang=js"
export * from "./course-work-details.vue?vue&type=script&lang=js"
import style0 from "./course-work-details.vue?vue&type=style&index=0&id=2d9d959f&prod&scoped=true&lang=css"
import style1 from "./course-work-details.vue?vue&type=style&index=1&id=2d9d959f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d959f",
  null
  
)

export default component.exports